import moment from 'moment';
import type { User } from '../graphQL';

export type SortDirection = 'asc' | 'desc';

// Shown in place of a name when a user has given us none
export const NO_NAME_PROVIDED = 'No name provided';
// Shown in place of a legal name when a user has not given one
export const LEGAL_NAME_NOT_PROVIDED = 'Not provided';
// Stands in for a student's name inside a sentence, e.g. "Video call with Student"
export const STUDENT_NAME_PLACEHOLDER = 'Student';

export const compareLastNames = (
  a: Pick<User, 'firstName' | 'lastName'>,
  b: Pick<User, 'firstName' | 'lastName'>
) => {
  const compared = a.lastName.localeCompare(b.lastName);
  return compared !== 0 ? compared : a.firstName.localeCompare(b.firstName);
};

export const compareNames = (
  a: { firstName: string; lastName: string },
  b: { firstName: string; lastName: string }
) => {
  const comparedFirstNames = a.firstName.localeCompare(b.firstName);
  if (comparedFirstNames !== 0) {
    return comparedFirstNames;
  }
  // if first names are the same, use last name as a tiebreaker
  return a.lastName.localeCompare(b.lastName);
};

export const compareDates = (a: string | null, b: string | null) => {
  const mA = moment(a || '');
  const mB = moment(b || '');
  if (!mA.isValid() && mB.isValid()) {
    return -1;
  }
  if (mA.isValid() && !mB.isValid()) {
    return 1;
  }
  return moment(mA).diff(moment(mB));
};

export const isOnCareTeam = (
  provider: { id: number },
  user: {
    careFlows?: ({ provider?: { id: number } | null } | null)[] | null;
    campusTeam?: { relationshipType: string; provider: { id: number } }[] | null;
  }
) => {
  return (
    Boolean(user.careFlows?.some(cf => cf?.provider?.id === provider.id)) ||
    Boolean(user.campusTeam?.find(i => i.provider.id === provider.id))
  );
};

export const taskStatuses = [
  'Account Setup',
  'Enrolled',
  'Intake',
  'Initial Evaluation',
  'Ongoing Care',
  'Discharged',
];

export function getUserOrgAbbreviation(user: {
  organization?: { parent?: { abbreviation: string } | null; abbreviation: string } | null;
}) {
  return user.organization?.parent?.abbreviation ?? user.organization?.abbreviation;
}
